import React, { useEffect, useState } from 'react';
import { Alert, Button, CircularProgress, Paper, TextField } from '@mui/material';
import api from '../services/api';

function BethaData() {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    getBethaData();
  }, []);

  const getBethaData = async () => {
    try {
      const response = await api.get('/betha-data');
      setFormData({
        username: response.data.data.username,
        password: response.data.data.password,
      });
    } catch (err) {
      showMessage(err.response?.data?.message || 'Algo de errado aconteceu.', 'error');
    }
  };

  const updateBethaData = async (data) => {
    try {
      setLoading(true);
      await api.patch('/betha-data', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      showMessage('Dados alterados com sucesso!', 'success');
    } catch (err) {
      showMessage(err.response?.data?.message || 'Algo de errado aconteceu.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async () => {
    const data = {
      username: formData.username,
      password: formData.password,
    };

    await updateBethaData(data);
  };

  const showMessage = (message, type) => {
    const alert = <Alert
      className="error-content"
      variant="outlined"
      severity={type}
    >
      {message}
    </Alert>;
    setMessage(alert);
    setTimeout(() => setMessage(null), 3000);
  };

  return (
    <div>
      <div className="align-center justify-between">
        <h1>Dados de login Betha Sistemas</h1>
      </div>
      <div className="w-100 h-100 align-center justify-center">
        {message}
        <Paper sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          padding: '2rem',
          gap: '1rem',
        }}>
          <div
            className="w-100"
            style={{
              display: 'flex',
              gap: '.5rem',
              flexDirection: 'column',
            }}
          >
            <div
              className="w-100"
              style={{
                display: 'flex',
                gap: '.5rem',
              }}
            >
              <TextField
                sx={{ width: '100%' }}
                size="small"
                id="username"
                name="username"
                label="Usuário"
                variant="outlined"
                disabled={loading}
                onChange={handleChange}
                value={formData.username}
              />
              <TextField
                sx={{ width: '100%' }}
                size="small"
                id="password"
                name="password"
                label="Senha"
                variant="outlined"
                disabled={loading}
                onChange={handleChange}
                value={formData.password}
              />
            </div>
          </div>
          <div
            className="w-100"
            style={{
              display: 'flex',
              gap: '.5rem',
              flexDirection: 'column',
            }}
          >
          </div>
          <div className="w-100">
            <Button
              sx={{ width: '150px', height: '40px' }}
              variant="outlined"
              color="success"
              onClick={handleSubmit}
              disabled={loading}
            >
              { loading ? <CircularProgress size={20} /> : 'Salvar' }
            </Button>
          </div>
        </Paper>
      </div>
    </div>
  );
}

export default BethaData;
